import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products")({
  beforeLoad: () => {
    throw redirect({ to: "/pharmacy", replace: true, statusCode: 301 });
  },
});
